export default "__VITE_ASSET__CEHkR_7v__"